"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var AdditivesPopup = /*#__PURE__*/function () {
  function AdditivesPopup(component) {
    (0, _classCallCheck2["default"])(this, AdditivesPopup);
    this.dom = {
      $component: component,
      $close: component.querySelector('.js-additives-popup-close'),
      $forceClose: component.querySelector('.js-additives-popup-force-close')
    }, this.state = {
      openLink: '#additives-popup',
      openDuration: 500,
      closeDuration: 500,
      animating: false,
      open: component.classList.contains('is-active'),
      activeClass: 'is-active'
    };
    this.keydownHandler = this.onKeydown.bind(this);
    this.clickHandler = this.onClick.bind(this);
    this.closeHandler = this.close.bind(this);
    this.forceCloseHandler = this.forceClose.bind(this);
    this.mount();
  }

  (0, _createClass2["default"])(AdditivesPopup, [{
    key: "mount",
    value: function mount() {
      var dom = this.dom,
          state = this.state;
      console.log('AdditivesPopup : mount', this);
      document.addEventListener('keydown', this.keydownHandler);
      document.addEventListener('click', this.clickHandler);
      dom.$close.addEventListener('click', this.closeHandler);
      dom.$forceClose.addEventListener('click', this.forceCloseHandler);
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var dom = this.dom,
          state = this.state;
      console.log('AdditivesPopup : unmount', this);
      document.removeEventListener('keydown', this.keydownHandler);
      document.removeEventListener('click', this.clickHandler);
      dom.$close.removeEventListener('click', this.closeHandler);
      dom.$forceClose.removeEventListener('click', this.forceCloseHandler);
    }
  }, {
    key: "toggle",
    value: function toggle(event) {
      var state = this.state;
      event.preventDefault();
      event.stopPropagation();
      console.log('AdditivesPopup : toggle', this);

      if (state.active) {
        this.close();
      } else {
        this.open();
      }
    }
  }, {
    key: "onKeydown",
    value: function onKeydown(event) {
      var state = this.state;
      console.log('AdditivesPopup : onKeydown', this, event);
      var escape = event.keyCode === 27;

      if (state.active && escape) {
        this.close();
      }
    }
  }, {
    key: "onClick",
    value: function onClick(event) {
      var state = this.state;
      console.log('AdditivesPopup : onClick', this, event);

      if (event.target.href && ~event.target.href.indexOf(state.openLink)) {
        this.toggle(event);
      }
    }
  }, {
    key: "open",
    value: function open() {
      var dom = this.dom,
          state = this.state;
      console.log('AdditivesPopup : open', this);

      if (!state.animating) {
        state.animating = true;
        dom.$component.setAttribute('aria-hidden', 'false');
        dom.$component.setAttribute('aria-expanded', 'true');
        setTimeout(function () {
          dom.$component.classList.add(state.activeClass);
        }, 25);
        setTimeout(function () {
          state.open = true;
          state.animating = false;
        }, state.openDuration);
      }
    }
  }, {
    key: "close",
    value: function close() {
      var dom = this.dom,
          state = this.state;
      console.log('AdditivesPopup : close', this);

      if (!state.animating) {
        state.animating = true;
        setTimeout(function () {
          dom.$component.classList.remove(state.activeClass);
        }, 25);
        setTimeout(function () {
          dom.$component.setAttribute('aria-hidden', 'true');
          dom.$component.setAttribute('aria-expanded', 'false');
          state.open = false;
          state.animating = false;
        }, state.closeDuration);
      }
    }
  }, {
    key: "forceClose",
    value: function forceClose(event) {
      var dom = this.dom,
          state = this.state;
      console.log('NewsletterPopup : forceClose', this, event);

      if (event.target === dom.$forceClose) {
        this.close();
      }
    }
  }]);
  return AdditivesPopup;
}();

exports["default"] = AdditivesPopup;